const services = [
  {
    title: "Réparation",
    desc: "Volet bloqué, moteur, sangle, cordon, tablier : nous réparons tous les types.",
    href: "/reparation-volet-roulant",
    icon: "ri-tools-line",
  },
  {
    title: "Dépannage urgence",
    desc: "Intervention rapide en cas de volet bloqué ou coincé, toutes marques.",
    href: "/depannage-urgence",
    icon: "ri-alarm-warning-line",
  },
  {
    title: "Remplacement de moteur",
    desc: "Moteur Somfy, Nice et autres marques. Installation et reprogrammation.",
    href: "/moteur-somfy",
    icon: "ri-flashlight-line",
  },
  {
    title: "Sangle",
    desc: "Remplacement de sangle et cordon usés, toutes dimensions et toutes marques.",
    href: "/sangle-volet-roulant",
    icon: "ri-links-line",
  },
  {
    title: "Tablier",
    desc: "Remplacement de lames ou de tablier complet en PVC et aluminium.",
    href: "/tablier-volet-roulant",
    icon: "ri-layout-masonry-line",
  },
  {
    title: "Motorisation",
    desc: "Transformation manuel vers électrique. Motorisation et programmation.",
    href: "/motorisation-somfy",
    icon: "ri-settings-4-line",
  },
  {
    title: "Pose",
    desc: "Pose et installation de volets roulants neufs, sur mesure et sur-mesure.",
    href: "/pose-volet-roulant",
    icon: "ri-add-box-line",
  },
];

export default function Services() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-brand-blue mb-3">
            Nos services à Haguenau
          </h2>
          <p className="text-brand-text text-base md:text-lg max-w-2xl mx-auto">
            Toutes nos prestations sont disponibles à Haguenau et dans les communes environnantes du nord du Bas-Rhin.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((s) => (
            <a
              key={s.title}
              href={s.href}
              className="group bg-white rounded-xl border border-brand-border p-5 md:p-6 hover:border-brand-cyan transition-all flex flex-col"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-brand-light mb-4">
                <i className={`${s.icon} text-brand-cyan text-lg`}></i>
              </div>
              <h3 className="text-brand-blue text-base font-bold mb-2 group-hover:text-brand-cyan transition-colors">
                {s.title}
              </h3>
              <p className="text-brand-text text-sm leading-relaxed">{s.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}